'use client'

import { Loader2 } from 'lucide-react'
import * as React from 'react'
import { UseFormReturn } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { PasswordResetFormData } from '../hooks/usePasswordResetFlow'

interface EmailStepProps {
  form: UseFormReturn<PasswordResetFormData>
  onSubmit: (data: PasswordResetFormData) => Promise<void> | void
  isLoading: boolean
  isInitializing: boolean
}

export function EmailStep({ form, onSubmit, isLoading, isInitializing }: EmailStepProps) {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="email"
          rules={{
            required: 'Email is required',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Invalid email format'
            }
          }}
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-900">Email</FormLabel>
              <FormControl>
                <Input
                  placeholder="Enter your email address"
                  type="email"
                  required
                  {...field}
                  className="border-gray-300 bg-white text-gray-900 placeholder:text-gray-500"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button
          type="submit"
          className="w-full bg-blue-600 text-white hover:bg-blue-700"
          disabled={isLoading || isInitializing}
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Sending code...
            </>
          ) : isInitializing ? (
            'Initializing...'
          ) : (
            'Send Code'
          )}
        </Button>
      </form>
    </Form>
  )
}
